var PageTextNote = require('./text');

module.exports = PageTextNote.extend({
    init: 'K',
    // like html notes, don't allow to create; all will be sent to server with type 'T'
    // and if 'autoUtr' prop of container (bin/FC) is true, will be sent back down as type 'K'
    notCreatable: true, 
    /* for the view, apply the same class as the text note */
    getNoteClass: function() {
        return PageTextNote.prototype.getNoteClass();
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/keyedTextNote.js
 ** module id = 286
 ** module chunks = 0
 **/